// User
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const GET_ADVISORS = 'GET_ADVISORS'
export const GET_INVESTMENT_STATS = 'GET_INVESTMENT_STATS'
export const TOKEN = 'TOKEN'
export const TUTORIAL_FINISHED = 'TUTORIAL_FINISHED'

// Assets
export const PROFIL_PICTURE = 'PROFIL_PICTURE'

// Estate
export const FILL_ESTATE = 'FILL_ESTATE'

export const FORCE_COMPLETE_PROFILE = 'FORCE_COMPLETE_PROFILE'



// WEBPACK FOOTER //
// ./src/store/modules/Users/types.js